import * as sterlingparker from './Divider.styles.sterlingparker';
import * as puntgenie from './Divider.styles.puntgenie';
import * as junglebet from './Divider.styles.junglebet';
import * as betprofessor from './Divider.styles.betprofessor';
import * as fiestabet from './Divider.styles.fiestabet';
import * as puntcity from './Divider.styles.puntcity';
import * as betgalaxy from './Divider.styles.betgalaxy';
import * as betroyale from './Divider.styles.betroyale';
import * as juicybet from './Divider.styles.juicybet';
import * as goldenrush from './Divider.styles.goldenrush';
import * as vikingbet from './Divider.styles.vikingbet';
import * as wellbet from './Divider.styles.wellbet';
import * as questbet from './Divider.styles.questbet';
import * as sugarcastle from './Divider.styles.sugarcastle';
import * as oldgill from './Divider.styles.oldgill';
import * as buffalobet from './Divider.styles.buffalobet';
import * as titanbet from './Divider.styles.titanbet';
import * as gigabet from './Divider.styles.gigabet';
import * as slambet from './Divider.styles.slambet';
import * as betstride from './Divider.styles.betstride';
import * as templebet from './Divider.styles.templebet';
import * as goldenbet888 from './Divider.styles.goldenbet888';
import * as hyperbet from './Divider.styles.hyperbet';
import * as bet777 from './Divider.styles.bet777';
import * as chromabet from './Divider.styles.chromabet';
import * as bet575 from './Divider.styles.bet575';
import * as epicodds from './Divider.styles.epicodds';
import * as volcanobet from './Divider.styles.volcanobet';
import * as pyramidbet from './Divider.styles.pyramidbet';
import * as magnumbet from './Divider.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  puntgenie,
  junglebet,
  betprofessor,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  wellbet,
  questbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  volcanobet,
  pyramidbet,
  magnumbet,
};
